<template>
	<div class="class">
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/task" class="cl_gray">布置作业</router-link>  >  作业篮</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="basket_success tc">
					<div class="basket_success_item">
						<img src="../../../static/success_green.png" class="mar10" />
						<span class="f26px cl_green">成功布置作业</span>
					</div>
					<div class="basket_success_item mat60">
						<router-link to="/record" replace class="cl_violet f18px radius20 basket_success_record">查看作业记录</router-link>
						<router-link to="/basket" replace class="cl_white f18px radius20 basket_success_again">继续布置</router-link>
					</div>
					<div class="basket_success_item mat70">
						<img :src="public.qr_code" class="basket_success_qr" />
						<div>
							<p class="f20px">微信扫码关注公众号</p>
							<p class="f16px cl_gray">随时在手机上监督作业完成情况</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'basket_success',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "作业篮",
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			
		},
	}
</script>

<style>
</style>
